/* global pannellum */
var Acr = Acr || {};

Acr.ThreeSixty = function () {
  var $threeSixty;
  var $threeSixtyGalleries;
  var $clickAndDragBtn;
  var $threeSixtyTabs;
  var $threeSixtyTabsDisclaimers;
  var $threeSixtyColorSelectors;
  var $threeSixtyCTABtn;
  var galleriesArray = [];
  var clickAndDragBtnEnabled = true;

  const threeSixtyGallerySelector = '.js-three-sixty-gallery';
  const clickAndDragBtnSelector = '.js-click-and-drag-btn';
  const spinnerSelector = '.js-three-sixty-spinner';
  const galleryImgSelector = '.js-three-sixty-img';
  const galleryPanoramaSelector = '.js-three-sixty-panorama';
  const panoPictureSelector = '.js-three-sixty-pano-picture';
  const panoramaControlsSelector = '.js-panorama-controls';
  const panoramaZoomInSelector = '.js-panorama-zoom-in';
  const panoramaZoomOutSelector = '.js-panorama-zoom-out';
  const threeSixtyTabSelector = '.js-three-sixty-tab';
  const tabDisclaimerSelector = '.js-tab-disclaimer';
  const colorsContainerSelector = '.js-colors-container';
  const colorSelector = '.js-three-sixty-color';
  const colorsDescriptionSelector = '.js-color-description';
  const ctaBtn = '.js-cta-btn';
  const activeClass = 'is-active';
  const hideClass = 'hide';
  const loadedClass = 'loaded';
  const imgExt = '.jpg';

  function initSelectors(element) {
    $threeSixty = element;
    $clickAndDragBtn = $threeSixty.querySelector(clickAndDragBtnSelector);
    $threeSixtyGalleries = $threeSixty.querySelectorAll(threeSixtyGallerySelector);
    $threeSixtyTabs = $threeSixty.querySelectorAll(threeSixtyTabSelector);
    $threeSixtyTabsDisclaimers = $threeSixty.querySelectorAll(tabDisclaimerSelector);
    $threeSixtyColorSelectors = $threeSixty.querySelectorAll(colorsContainerSelector);
    $threeSixtyCTABtn = $threeSixty.querySelector(ctaBtn);
  }

  // Init each gallery of the 360
  function initGalleries() {
    $threeSixtyGalleries.forEach(function ($gallery) {
      var galleryId = $gallery.id;
      var threeSixtyGallery = new Gallery($gallery); // One "Gallery" instance for each gallery (exterior/interior)
      galleriesArray[galleryId] = threeSixtyGallery; // The the gallery instance to the galleries array
    });
  }

  function bindEvents() {
    // Attachment of click event for the "Click and Drag Button"
    $clickAndDragBtn.addEventListener('click', clickAndDragBtnHandler);

    // Attachment of click events for each of the tabs
    $threeSixtyTabs.forEach(function (tab) {
      tab.addEventListener('click', tabClickHandler);
    });
  }

  // Function that is triggered when the "Click and Drag" button is clicked
  function clickAndDragBtnHandler() {
    var activeGalleryId;
    var $threeSixtyActiveGallery = $threeSixty.querySelector('.' + activeClass); // Gets the active gallery
    activeGalleryId = $threeSixtyActiveGallery.id;
    galleriesArray[activeGalleryId].initGallery(); // Find the active gallery in the galleries array to init the active gallery
    clickAndDragBtnEnabled = false;
    $clickAndDragBtn.classList.add(hideClass);
  }

  // Function that is triggered when a "Tab" is clicked
  function tabClickHandler(event) {
    var tabGalleryId = event.currentTarget.getAttribute('data-gallery-id');

    // Add the "active" class to the tab that was clicked and removes the class to the others
    // If the tab gallery is not initialized, init all the content of the tab
    $threeSixtyGalleries.forEach(function ($gallery) {
      var galleryId = $gallery.id;
      if (galleryId === tabGalleryId) {
        $gallery.classList.add(activeClass);
        if (!$gallery.classList.contains(loadedClass) && !clickAndDragBtnEnabled) {
          galleriesArray[galleryId].initGallery();
        }
      } else {
        $gallery.classList.remove(activeClass);
      }
    });

    // Change the "disclaimer" text according to the selected tab
    $threeSixtyTabsDisclaimers.forEach(function ($disclaimer) {
      var disclaimerId = $disclaimer.getAttribute('data-gallery-id');
      if (disclaimerId === tabGalleryId) {
        $disclaimer.classList.add(activeClass);
      } else {
        $disclaimer.classList.remove(activeClass);
      }
    });

    // Change the "colors" container according to the selected tab
    $threeSixtyColorSelectors.forEach(function ($container) {
      var containerId = $container.getAttribute('data-gallery-id');
      if (containerId === tabGalleryId) {
        $container.classList.add(activeClass);
      } else {
        $container.classList.remove(activeClass);
      }
    });

    // Add styles for the selected tab
    $threeSixtyTabs.forEach(function (tab) {
      tab.classList.remove(activeClass);
    });

    event.currentTarget.classList.add(activeClass);
  }

  function Gallery(pGallery) {
    var $gallery = pGallery;
    var $threeSixtyGalleryImg;
    var $spinner;
    var $galleryColors;
    var $galleryColorDescription;
    var $panoStaticPicture;
    var $panoStaticPictureSource;
    var $panoStaticPictureImg;
    var galleryId = $gallery.id;
    var dataFrames;
    var pointerStartPosX = 0;
    var pointerEndPosX = 0;
    var monitorStartTime = 0;
    var monitorInt = 10;
    var pointerDistance = 0;
    var pointerSpeed = 10; // Speed of the pointer
    var framesPerGallery = 0; // Frames for the gallery
    var currentFrame = 0;
    var expectedFrame = 0;
    var dataSource = '';
    var galleryType = $gallery.getAttribute('data-type');
    var matchMedia = window.matchMedia('(min-width: ' + (Constants.breakpoints.lg) + 'px)');
    var colorsStringSelector = `${colorsContainerSelector}${'[data-gallery-id="'}${galleryId}${'"]'}`; // Get only the colors for the current gallery instance
    var $colorsContainer = $threeSixty.querySelector(colorsStringSelector);
    var panoView;
    var panoColorScenes = {}; // Empty object for storing interior color scenes

    // Add the matchMedia listener and load the first image only if the gallery type is "threesixty"
    if (galleryType === 'threesixty') {
      matchMedia.addListener(updateImgDataSource);
      loadFirstImgSrc();
    }

    // If the color container exists in the markup, attach the click event for each color
    if ($colorsContainer) {
      var activeColorSwatch = null;
      $galleryColors = $colorsContainer.querySelectorAll(colorSelector);
      $galleryColorDescription = $colorsContainer.querySelectorAll(colorsDescriptionSelector);

      // Attachment of click events for each color depending on the gallery type
      if (galleryType === 'threesixty') {
        $galleryColors.forEach(function (color) {
          // Search for the active swatch in order to add the color swatch code to the cta
          if (color.classList.contains(activeClass)) {
            activeColorSwatch = color;
          }

          color.addEventListener('click', changeColorThreeSixtyHandler);
        });

        if (activeColorSwatch) {
          updateColorSwatchCode(activeColorSwatch);
        }
      } else {
        $galleryColors.forEach(function (color) {
          color.addEventListener('click', changeColorPanoramaHandler);

          var interiorImg = color.getAttribute('data-pano-img');
          var interiorColorId = color.getAttribute('data-id');

          // Adding color keys and images to the "panoColorScenes" object
          panoColorScenes[interiorColorId] = {
            panorama: interiorImg,
          };
        });

        $panoStaticPicture = $threeSixty.querySelector(panoPictureSelector);
        $panoStaticPictureSource = $panoStaticPicture.querySelector('source');
        $panoStaticPictureImg = $panoStaticPicture.querySelector('img');
      }
    }

    // Load the "static" img for the 360 gallery depending on the screen size, img that is showed when the 360 is not initialized
    function loadFirstImgSrc() {
      const firstImgNumber = '01';
      $threeSixtyGalleryImg = $gallery.querySelector(galleryImgSelector);

      updateImgDataSource();

      if ($threeSixtyGalleryImg.getAttribute('loading') === 'lazy' && !Acr.LazyLoadingHelper.isLazyLoadingNative()) {
        $threeSixtyGalleryImg.setAttribute('data-src', `${dataSource}${firstImgNumber}${imgExt}`);
      } else {
        $threeSixtyGalleryImg.src = `${dataSource}${firstImgNumber}${imgExt}`;
      }
      $threeSixtyGalleryImg.classList.remove(hideClass);
    }

    // Get the data source for the Img depending on the size of the screen
    function updateImgDataSource() {
      var previousDataSource = dataSource;

      if (matchMedia.matches) {
        dataSource = $gallery.getAttribute('data-source-large');
      } else {
        dataSource = $gallery.getAttribute('data-source-small');
      }

      if (previousDataSource !== '') {
        $threeSixtyGalleryImg.src = $threeSixtyGalleryImg.src.replace(previousDataSource, dataSource);
      }
    }

    // Function that is activated when a "color" of a gallery type "threesixty" is clicked
    function changeColorThreeSixtyHandler(event) {
      var dataSourceSmall = event.currentTarget.getAttribute('data-source-small');
      var dataSourceLarge = event.currentTarget.getAttribute('data-source-large');
      $gallery.setAttribute('data-source-small', dataSourceSmall);
      $gallery.setAttribute('data-source-large', dataSourceLarge);

      updateActiveColor(event.currentTarget);
      updateImgDataSource();

      if ($gallery.classList.contains(loadedClass)) {
        var imagesToLoad = dataFrames;
        $spinner.classList.remove(hideClass);

        // Load one image per frame
        for (var i = 1; i <= dataFrames; i++) {
          var newImage = new Image();
          var formattedIndex = ('0' + i).slice(-2); // Format the index in two digits, example: 1 --> 01
          var newUrl = `${dataSource}${formattedIndex}${imgExt}`;
          newImage.src = newUrl;

          newImage.onload = function () {
            imagesToLoad--;
            if (imagesToLoad === 0) {
              // Lines executed when all images are ready
              $spinner.classList.add(hideClass);
            }
          };
        }
      }

      updateColorSwatchCode(event.currentTarget);
    }

    // Function that is activated when a "color" of a gallery type "pano" is clicked
    function changeColorPanoramaHandler(event) {
      var dataSourceSmall = event.currentTarget.getAttribute('data-source-small');
      var dataSourceLarge = event.currentTarget.getAttribute('data-source-large');
      var newPanoImg = event.currentTarget.getAttribute('data-pano-img');
      var selectedColor = event.currentTarget.getAttribute('data-id');

      // Update the data attributes for the current gallery
      $gallery.setAttribute('data-pano-img', newPanoImg);
      $gallery.setAttribute('data-color-id', selectedColor);

      updateActiveColor(event.currentTarget);

      if ($gallery.classList.contains(loadedClass)) {
        $spinner.classList.remove(hideClass);

        // Switch to the "pannellum" scene with the new color, keeping the same position and zoom
        panoView.loadScene(selectedColor, panoView.getPitch(), panoView.getYaw(), panoView.getHfov());

        panoView.on('load', function () {
          $spinner.classList.add(hideClass);
        });
      } else {
        // Update the pictures attributes and image source
        $panoStaticPictureSource.setAttribute('srcset', dataSourceLarge);
        $panoStaticPictureImg.setAttribute('srcset', dataSourceSmall);
        $panoStaticPictureImg.setAttribute('src', dataSourceSmall);
      }
    }

    function updateActiveColor(selectedColor) {
      var colorId = selectedColor.getAttribute('data-id');

      // Add styles for the selected color
      $galleryColors.forEach(function (color) {
        color.classList.remove(activeClass);
      });
      selectedColor.classList.add(activeClass);

      // Update the color description text
      $galleryColorDescription.forEach(function (description) {
        var descriptionId = description.getAttribute('data-id');
        if (descriptionId === colorId) {
          description.classList.add(activeClass);
        } else {
          description.classList.remove(activeClass);
        }
      });
    }

    // Function that update the color swatch code in the CTA href base on the active color swatch
    function updateColorSwatchCode(colorSwatch) {
      if ($threeSixtyCTABtn) {
        var ctaHrefParams = new URL($threeSixtyCTABtn.href).searchParams;
        var colorCode = colorSwatch.getAttribute('data-color-code');

        if (ctaHrefParams.has('exterior')) {
          var extParam = ctaHrefParams.get('exterior');
          $threeSixtyCTABtn.href = $threeSixtyCTABtn.href.replace(extParam, colorCode);
        } else {
          var oldParams = ctaHrefParams.toString();
          ctaHrefParams.append('exterior', colorCode);
          var newParams = ctaHrefParams.toString();

          if (oldParams === '') {
            $threeSixtyCTABtn.href += '?' + newParams;
          } else {
            $threeSixtyCTABtn.href = $threeSixtyCTABtn.href.replace(oldParams, newParams);
          }
        }
      }
    }

    // Function to init the "active" gallery depending on the type of gallery
    function initGallery() {
      if (galleryType === 'threesixty') {
        initThreeSixty();
      } else {
        initPannellum();
      }
    }

    // Function to init the "exterior three sixty" and load all required images
    function initThreeSixty() {
      dataFrames = parseInt($gallery.getAttribute('data-frames'), 10);
      var imagesToLoad = dataFrames;
      $spinner = $gallery.querySelector(spinnerSelector);
      framesPerGallery = dataFrames;
      $spinner.classList.remove(hideClass);

      // Load one image per frame
      for (var i = 1; i <= dataFrames; i++) {
        var newImage = new Image();
        var formattedIndex = ('0' + i).slice(-2); // Format the index in two digits, example: 1 --> 01
        var newUrl = `${dataSource}${formattedIndex}${imgExt}`;
        newImage.src = newUrl;

        newImage.onload = function () {
          imagesToLoad--;
          if (imagesToLoad === 0) {
            // Lines executed when all images are ready
            $spinner.classList.add(hideClass);
            addThreeSixtyListeners();
            galleryLoaded();
          }
        };
      }
    }

    // Add the class "loaded" to the active gallery when the content is loaded
    function galleryLoaded() {
      $gallery.classList.add(loadedClass);
    }

    // Event listeners for the exterior gallery
    function addThreeSixtyListeners() {
      $gallery.addEventListener('mousedown', mouseDownHandler);
      $gallery.addEventListener('mouseup', mouseUpHandler);
      $gallery.addEventListener('touchstart', mouseDownHandler);
      $gallery.addEventListener('touchend', mouseUpHandler);
    }

    // Events that are executed when the user presses the mouse or touches the screen and keeps pressing
    function mouseDownHandler(event) {
      event.preventDefault();
      pointerStartPosX = getPointerEvent(event).pageX; // Assign the mouse pointer X position
      event.currentTarget.addEventListener('mousemove', mouseMoveHandler);
      event.currentTarget.addEventListener('touchmove', mouseMoveHandler);
    }

    // Events that are executed when the user releases the mouse or stops pressing the screen
    function mouseUpHandler(event) {
      event.preventDefault();
      event.currentTarget.removeEventListener('mousemove', mouseMoveHandler);
      event.currentTarget.removeEventListener('touchmove', mouseMoveHandler);
    }

    // Events that are executed when the user moves the mouse while holding it down or moves the finger while holding down the screen
    function mouseMoveHandler(event) {
      event.preventDefault();
      var currentPosition;
      var currentGallery = event.currentTarget;
      pointerEndPosX = getPointerEvent(event).pageX; // Assign the mouse pointer X position

      if (monitorStartTime < new Date().getTime() - monitorInt) {
        var sign; // used to convert the "currentPosition" to a positive or negative number
        pointerDistance = pointerEndPosX - pointerStartPosX; // pointer position from initial pressure to stop
        sign = pointerDistance < 0 ? -1 : 1;
        // Applying "Math.abs" to remove the negative symbol from "pointerDistance", then after the "Math.ceil" on the calculation, multiply the result by "sign (1 or -1)" to add the symbol
        currentPosition = Math.ceil(framesPerGallery * pointerSpeed * (Math.abs(pointerDistance) / currentGallery.offsetWidth)) * sign;
        expectedFrame = currentFrame + currentPosition;
        refreshFrame();
        monitorStartTime = new Date().getTime();
        pointerStartPosX = getPointerEvent(event).pageX;
      }
    }

    // Refresh currentFrame when the user moves the mouse
    function refreshFrame() {
      var framesDiff;
      var ease;
      if (currentFrame !== expectedFrame) {
        framesDiff = Math.ceil((expectedFrame - currentFrame) * 0.1);
        ease = expectedFrame < currentFrame ? Math.floor((expectedFrame - currentFrame) * 0.1) : framesDiff;
        currentFrame += ease;
        changeImageSource();
      }
    }

    // Change the image source depending on the current frame and the frames per gallery
    function changeImageSource() {
      var imgNumber = -(Math.ceil(currentFrame % framesPerGallery)) + 1;
      if (imgNumber <= 0) {
        imgNumber += framesPerGallery;
      }
      var formattedNumber = ('0' + imgNumber).slice(-2); // Format the number in two digits, example: 1 --> 01
      var newSrc = `${dataSource}${formattedNumber}${imgExt}`;
      $threeSixtyGalleryImg.src = newSrc;
    }

    function getPointerEvent(event) {
      return event.targetTouches ? event.targetTouches[0] : event;
    }

    function initPannellum() {
      $spinner = $gallery.querySelector(spinnerSelector);
      var $panorama = $gallery.querySelector(galleryPanoramaSelector);
      var $panoramaControls = $panorama.querySelector(panoramaControlsSelector);
      var $panoramaZoomIn = $panorama.querySelector(panoramaZoomInSelector);
      var $panoramaZoomOut = $panorama.querySelector(panoramaZoomOutSelector);
      var interiorImg = $gallery.getAttribute('data-pano-img');
      var interiorColorId = $gallery.getAttribute('data-color-id');
      var zoomButtonsDisabled = false;
      var initialScenes = {}; // Empty object for storing interior color scenes

      // Adding color keys and images to the "initialScenes" object
      initialScenes[interiorColorId] = {
        panorama: interiorImg,
      };

      $spinner.classList.remove(hideClass);

      // Create a "pannellum" object with its properties
      panoView = pannellum.viewer($panorama, {
        autoLoad: true,
        showControls: false,
        mouseZoom: false,
        hfov: 90, // Initial zoom level. minimum 50 / maximum 120.
        pitch: -12, // Sets the panorama’s starting pitch position in degrees
        default: {
          firstScene: interiorColorId,
        },
        scenes: (Object.keys(panoColorScenes).length !== 0) ? panoColorScenes : initialScenes, // Use "panoColorScenes" if it has colors, otherwise use "initialScenes"
      });

      // Actions executed when the panoramic view is ready
      panoView.on('load', function () {
        $spinner.classList.add(hideClass);
        $panoramaControls.classList.remove(hideClass);
        galleryLoaded();
        attachControlsEvents();
      });

      function attachControlsEvents() {
        // Attachment of click event for the "Zoom In" button
        $panoramaZoomIn.addEventListener('click', zoomInButtonHandler);

        // Attachment of click event for the "Zoom Out" button
        $panoramaZoomOut.addEventListener('click', zoomOutButtonHandler);
      }

      // Actions executed when the zoom-in button is clicked
      function zoomInButtonHandler() {
        panoView.setHfov(panoView.getHfov() - 15);

        // This block removes click event listener for the zoom buttons to avoid strange "multiple click" behavior
        $panoramaZoomIn.removeEventListener('click', zoomInButtonHandler);
        $panoramaZoomOut.removeEventListener('click', zoomOutButtonHandler);
        zoomButtonsDisabled = true;
      }

      // Actions executed when the zoom-out button is clicked
      function zoomOutButtonHandler() {
        panoView.setHfov(panoView.getHfov() + 15);

        // This block removes click event listener for the zoom buttons to avoid strange "multiple click" behavior
        $panoramaZoomIn.removeEventListener('click', zoomInButtonHandler);
        $panoramaZoomOut.removeEventListener('click', zoomOutButtonHandler);
        zoomButtonsDisabled = true;
      }

      // Actions executed when the zoom animation is finished
      panoView.on('animatefinished', function () {
        // This block adds click event listener for the zoom buttons when the zoom finish
        if (zoomButtonsDisabled) {
          zoomButtonsDisabled = false;
          $panoramaZoomIn.addEventListener('click', zoomInButtonHandler);
          $panoramaZoomOut.addEventListener('click', zoomOutButtonHandler);
        }
      });
    }

    return {
      initGallery: initGallery,
    };
  }

  function init(element) {
    initSelectors(element);
    initGalleries();
    bindEvents();
  }

  return {
    init: init,
  };
};
